<app-loading-overlay [isLoading]="newEmail" class="dialog-fill">
  <bv-dialog-title>{{ "RESET_EMAIL" | translate }}</bv-dialog-title>
  <bv-dialog-body class="min-300">
    <div class="flex-1 flex flex-col">
      <bv-form-field
        label="{{ 'EMAIL' | translate }}"
        [error]="(isUserAlreadyExists || !emailInput.validity.valid) ? ('WRONG_EMAIL' | translate) : null"
      >
        <input
          bv-input
          type="email"
          name="profEmail"
          [(ngModel)]="email"
          email
          required
          #emailInput
        />
      </bv-form-field>
      <bv-form-field
        label="{{ 'PASSWORD' | translate }}"
        hint="{{ 'PASSWORD_MESSAGE' | translate }}"
        [error]="isWrongPassword ? ('WRONG_PASSWORD' | translate) : null"
      >
        <input
          bv-input
          type="password"
          name="profPassword"
          [(ngModel)]="password"
          required
        />
      </bv-form-field>
    </div>
  </bv-dialog-body>
  <bv-dialog-footer>
    <app-close-dialog-button></app-close-dialog-button>
    <button
      bv-button variant="primary" (click)="resetEmail()"
      [disabled]="
        this.email === this.auth.userInfo.email ||
        !password ||
        !emailInput.validity.valid
      "
>
      {{ "CONFIRM" | translate }}
    </button>
  </bv-dialog-footer>
</app-loading-overlay>
